import React from 'react';
import ReactDOM from 'react-dom/client';
// Bootstrap's JS (dropdowns/modals) via package manager instead of the
// legacy compiled theme bundle. Importing the bundle
// registers Bootstrap's data-api click delegation on document, so
// data-bs-toggle elements rendered by React work without per-element wiring.
import 'bootstrap';
import { App } from './App';
import { AppErrorBoundary } from './shell/AppErrorBoundary';
import { DialogHost } from './shell/dialogs';
import './styles/global.css';
import './styles/login-redesign.css';
import './shell/platform-redesign.css';
import './mailing/mailing.css';

// DEV: *.localhost neumí sdílet session cookie napříč subdoménami (Chrome
// odmítá Domain=localhost) → přepnutí Space by chtělo nový login. lvh.me je
// veřejné DNS → 127.0.0.1, ale reálná doména, takže Domain=.lvh.me sdílí cookie.
// Proto v devu přesměrujeme *.localhost → *.lvh.me (zachová subdoménu/path),
// ať uživatel zůstane přihlášený na všechny přidělené Spaces. Prod (reálná
// doména) se netýká.
if (import.meta.env.DEV) {
  const h = window.location.hostname;
  if (h === 'localhost' || h.endsWith('.localhost')) {
    const target = h.replace(/localhost$/, 'lvh.me');
    const port = window.location.port ? `:${window.location.port}` : '';
    window.location.replace(
      `${window.location.protocol}//${target}${port}${window.location.pathname}${window.location.search}${window.location.hash}`,
    );
  }
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
    <DialogHost />
  </React.StrictMode>,
);
